import React from 'react';
import { Modal, Box, Text, Button } from '@rsos/components/capstone/base';
import {
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@rsos/components/capstone/base/Modal/ModalComponents';
import { ButtonContainer } from './Modal.styles';

const DeleteCredentialModal = ({
  onClose,
  isOpened,
  handleDeleteCredential,
}) => {
  return (
    <Modal
      id="edit-user-modal"
      isOpened={isOpened}
      onClose={onClose}
      width={350}
    >
      <ModalHeader onClose={onClose}>
        <Box>
          <Text size="xlarge" color="primaryText">
            Are you sure you want to
          </Text>
          <Text size="xlarge" color="primaryText" fontWeight="bold">
            delete this credential?
          </Text>
        </Box>
      </ModalHeader>
      <>
        <ModalBody>
          <Text size="small" color="secondaryText">
            Deleting this credential will mean your entire organization will no
            longer have access to Axon’s data.
          </Text>
        </ModalBody>

        <ModalFooter justify="flex-end">
          <ButtonContainer horizontal width={1}>
            <Button
              grow
              btnType="tertiary"
              onClick={onClose}
              size="large"
              ml={0}
            >
              No, Cancel
            </Button>
            <Button
              size="large"
              grow
              btnType="primary"
              form="addUserModal"
              mr={0}
              onClick={handleDeleteCredential}
            >
              Yes, Delete
            </Button>
          </ButtonContainer>
        </ModalFooter>
      </>
    </Modal>
  );
};

export default DeleteCredentialModal;
